export default "__VITE_ASSET__BG92YQ28__"